import React from 'react';

import {Modal} from '@forecast-it/design-system';
import {DateRange, dateRangeToYMD} from '../../../shared/util/DateUtil';

import {handleCopyAll, handleCopyWithoutDoneTasks} from './TimesheetsCopyLastWeekModalLogic';

type TimesheetsCopyLastWeekModalFooterProps = {
	personId: string;
	copyDateRange: DateRange;
	closeModal: () => void;
	onCopyCallback: () => void;
	copyDone: boolean;
	copyFullWeek: boolean;
};
export function TimesheetsCopyLastWeekModalFooter({
	personId,
	copyDateRange,
	closeModal,
	onCopyCallback,
	copyDone,
	copyFullWeek,
}: TimesheetsCopyLastWeekModalFooterProps): React.ReactElement {
	const copyDateRangeYMD = dateRangeToYMD(copyDateRange);

	return (
		<Modal.Footer>
			<Modal.PrimaryFooterButton
				dataCy="copy-last-week-primary-button"
				key={'modal_primaryFooterButton_copy_wo_done_tasks_key'}
				onPress={() =>
					copyDone
						? handleCopyAll(personId, copyDateRangeYMD, onCopyCallback, closeModal)
						: handleCopyWithoutDoneTasks(personId, copyDateRangeYMD, onCopyCallback, closeModal)
				}
			>
				{`Copy from previous ${copyFullWeek ? 'week' : 'day'}`}
			</Modal.PrimaryFooterButton>
		</Modal.Footer>
	);
}
